import React, { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import BancoPreciosRefContent from "components/BancoPreciosReferencia/BancoPreciosRefContent"
import { useParams } from "react-router-dom"
import * as amplitude from "@amplitude/analytics-browser"

import { Container } from "reactstrap"
import { RecordPageView } from "App"
import { ListBank } from "./ListBank"

import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { BANKS_PUBLIC } from "constants/entitlements"

const getName = (uri, referencia) => {
  for (let cat of referencia.categorias) {
    if (cat.uri == uri) {
      return cat.name
    }
  }
}

const BancoDePreciosReferenciaC = () => {
  RecordPageView()
  const params = useParams()
  const referencia = params.referencia
  const tipo = params.tipo
    ? getName(params.tipo, ListBank[referencia])
    : ListBank[referencia].categorias[0].name

  useEffect(() => {
    amplitude.track({
      event_type: "Banco de precios referencia visited",
      event_properties: { referencia: referencia, tipo: tipo },
    })
  }, [])

  return (
    <EntitlementPageGuard permission={BANKS_PUBLIC}>
      <div className="page-content">
        <Helmet>
          <title>Planhopper | Banco de precios </title>
        </Helmet>
        <Container fluid>
          {tipo.length > 0 ? (
            <BancoPreciosRefContent tipo={tipo} referencia={referencia} />
          ) : null}
        </Container>
      </div>
    </EntitlementPageGuard>
  )
}

export default BancoDePreciosReferenciaC
